namespace SorAraBul.Administration {
    export namespace UserCreditPaymentOrderService {
        export const baseUrl = 'Administration/UserCreditPaymentOrder';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UserCreditPaymentOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UserCreditPaymentOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Administration/UserCreditPaymentOrder/Retrieve",
            List = "Administration/UserCreditPaymentOrder/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UserCreditPaymentOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
